/**
 * Lightweight client-side logger for the CTM Chat widget.
 *
 * Levels: error=0, warn=1, info=2, debug=3
 * Default level: 'warn' (errors + warnings only in production).
 *
 * Activation:
 *   <ctm-chat token="..." debug></ctm-chat>   → sets level to 'debug'
 *   Runtime: logger.setLevel('debug')          → toggle at runtime
 */

const LEVELS = { error: 0, warn: 1, info: 2, debug: 3 };
const PREFIX = '[CTM Chat]';

export class ClientLogger {
  constructor(level = 'warn') {
    this.level = LEVELS[level] ?? LEVELS.warn;
  }

  setLevel(level) {
    this.level = LEVELS[level] ?? LEVELS.warn;
  }

  error(msg, ...args) {
    if (this.level >= LEVELS.error) console.error(PREFIX, msg, ...args);
  }

  warn(msg, ...args) {
    if (this.level >= LEVELS.warn) console.warn(PREFIX, msg, ...args);
  }

  info(msg, ...args) {
    if (this.level >= LEVELS.info) console.log(PREFIX, msg, ...args);
  }

  debug(msg, ...args) {
    if (this.level >= LEVELS.debug) console.log(PREFIX, '[debug]', msg, ...args);
  }
}
